import { createFileRoute } from '@tanstack/react-router';
import { getPostBySlug } from '../../../content/blog/posts';
import { buildBlogHead, buildHead } from '../../../utils/seo';

export const Route = createFileRoute('/_layout/blog/$slug')({
  head: ({ params }) => {
    const meta = getPostBySlug(params.slug);
    if (!meta) {
      return buildHead('/blog');
    }
    return buildBlogHead(meta);
  },
});
